import React from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../../components/PrivateRoute";
import Home from "../home/Index";
import Home2 from "../home2/Index"
import Login from "../Account/Login";
import MyProfile from "../profile";
import RegularRoute from "../../components/RegularRoute";


const Router = () => {
  // const userData = getUserData();
  // const active = localStorage.getItem("selection");
  // console.log(active);
  return (
    <Routes>
      <Route element={<RegularRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="/:ref" element={<Home />} />
        <Route path="/ref/:ref" element={<Home2 />} />

        <Route path="/login" element={<Login />} />
        <Route
          path="/myprofile"
          element={<PrivateRoute>{<MyProfile />}</PrivateRoute>}
        />
      </Route>
    </Routes>
  );
};

export default Router;
